// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5a553931","239":"f0461c1d","455":"ab694289"}[chunkId] + ".chunk.js";
};